import { Component, OnInit, ViewChild } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { Subject } from 'rxjs';
import { ErrorReportService } from 'src/services/error-report.service';
import { HttpService } from 'src/services/http.service';

@Component({
  selector: 'app-desired-job-title-report',
  templateUrl: './desired-job-title-report.component.html',
  styleUrls: ['./desired-job-title-report.component.scss']
})
export class DesiredJobTitleReportComponent implements OnInit {

  datasource: MatTableDataSource<any> = new MatTableDataSource<any>();
  displayedColumns: string[] = ['name', 'records'];
  columnsDisplayName = {
    name: 'Cargo desejado',
    records: 'Quantidade'
  }

  @ViewChild('pieChartContainer', { static: false }) pieChartContainer: any;
  pieChartWidth: number = 0;
  pieChartData: any;
  submiting: boolean = false;
  constructor(
    private http: HttpService,
    private erroReport: ErrorReportService
  ) { }

  ngOnInit(): void {
    const subject = new Subject<any>();
    subject.subscribe(({ trigger, scope }: any) => {      
      if (scope == 'analytics:desired_job_title')
        this.submiting = trigger == 'pre';
    })
    this.http.setLoadingIndicator(subject, 'analytics:desired_job_title')
  }

  getDesiredJobTitle() {

    this.http.list('analytics:desired_job_title')
      .subscribe(
        (desiredJobs: any) => {
          this.datasource.data = desiredJobs.map((item: any) => {
            return {
              name: (item.desired_job_title?.trim().length == 0 || item.desired_job_title == 'undefined') ? 'Não definido' : item.desired_job_title,
              records: item.records
            }
          });

          this.pieChartData = this.datasource.data
            .slice(1, 20)
            .map((item: any) => ({
              name: item.name,
              value: item.records
            }));

          setTimeout(() => {
            this.pieChartWidth = this.pieChartContainer._element.nativeElement.clientWidth - 100;
          }, 1000)

        },
        err => this.erroReport.showMessage(err)
      )

  }

}
